// define type
export type Age = string;

const ages: Age[] = ['0 - 2 yr', '3 - 5 yr', '6 - 8 yr', '9 - 11 yr'];

export default ages;
